// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo-ct-dark.png";

const date = new Date().getFullYear();

export default {
  brand: {
    name: "Impresia",
    image: logoCT,
    route: "/",
  },
  socials: [
    {
      icon: <FacebookIcon />,
      link: "#",
    },
    {
      icon: <TwitterIcon />,
      link: "#",
    },
    {
      icon: <GitHubIcon />,
      link: "#",
    },
    {
      icon: <YouTubeIcon />,
      link: "#",
    },
  ],
  menus: [
    {
      name: "empresa",
      items: [
        { name: "inicio", href: "/" },
        { name: "nosotros", href: "/pages/landing-pages/about-us" },
      ],
    },
    {
      name: "contacto",
      items: [{ name: "contáctanos", href: "/pages/landing-pages/contact-us" }],
    },
    {
      name: "legal",
      items: [{ name: "aviso de privacidad", href: "/pages/landing-pages/privacy" }],
    },
  ],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      Todos los derechos reservados. Copyright &copy; {date} Impresia S.A. de C.V.{" "}
    </MKTypography>
  ),
};
